<template>
  <div>
    <div class="inner-header ">
      <nav class="navbar fixed-top bg-white animate__animated animate__slideInRight">
        <a  @click="$router.go(-1)" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
               <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                  <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                  <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
               </g>
            </svg>
         </a>
         <a href="javascript:void(0);" class="link-title">Edit Enquiry</a>
      </nav>
    </div>
    <div class="inner-page bg-white animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card form-card">
                        <div class="card-body p-0 mt-4">
                            <div class="row">
                                <div class="col-12">
                                  <b-form  @submit.prevent="UpdateEnquiryDetails">
                                    <b-form-group>
                                      <label>NCD<span class="text-danger">*</span></label>
                                      <datetime type="datetime" v-model="UpdateEnquiry.next_call_date" required placeholder="Next Call Date And Time">
                                      </datetime>
                                    </b-form-group>
                                    <b-form-group>
                                      <label>VCM Done<span class="text-danger">*</span></label>
                                        <b-form-select  v-model="UpdateEnquiry.vcm_done" @input="CheckVCMValidation(UpdateEnquiry.vcm_done)" required :options="VCMList" ></b-form-select>
                                    </b-form-group>
                                    <b-form-group v-if="UpdateEnquiry.vcm_done === true">
                                      <label>VCM Done Date<span class="text-danger">*</span></label>
                                      <datetime type="date" v-model="UpdateEnquiry.vcm_done_date" :required="UpdateEnquiry.vcm_done === true" placeholder="VCM Done Date">
                                    </datetime>
                                    </b-form-group>
                                    <b-form-group>
                                      <label>Visited<span class="text-danger">*</span></label>
                                        <b-form-select v-model="UpdateEnquiry.visited" @input="CheckVistedValidation(UpdateEnquiry.visited)" :options="VisitedList" required></b-form-select>
                                    </b-form-group>
                                    <b-form-group v-if="UpdateEnquiry.visited === true">
                                      <label>Visited Date<span class="text-danger">*</span></label>
                                      <datetime type="date" v-model="UpdateEnquiry.visit_date" :required="UpdateEnquiry.visited === true" placeholder="Visited Date">
                                    </datetime>
                                    </b-form-group>
                                    <b-form-group>
                                      <label>OBM Done<span class="text-danger">*</span></label>
                                        <b-form-select  v-model="UpdateEnquiry.obm_done" @input="CheckOBMValidation(UpdateEnquiry.obm_done)" required :options="OBMList" ></b-form-select>
                                    </b-form-group>
                                    <b-form-group v-if="UpdateEnquiry.obm_done === true">
                                      <label>OBM Done Date<span class="text-danger">*</span></label>
                                      <datetime type="date" v-model="UpdateEnquiry.obm_done_date" :required="UpdateEnquiry.obm_done === true" placeholder="OBM Done Date">
                                    </datetime>
                                    </b-form-group>
                                    <b-form-group>
                                      <label>Select Status<span class="text-danger">*</span></label>
                                        <b-form-select v-model="UpdateEnquiry.status_id" @input="CheckStatusValidation(UpdateEnquiry.status_id)" :options="StatusList" required></b-form-select>
                                    </b-form-group>
                                    <b-form-group>
                                      <label>IsNri<span class="text-danger">*</span></label>
                                        <b-form-select   v-model="UpdateEnquiry.is_nri" required :options="NriList" ></b-form-select>
                                    </b-form-group>
                                    <b-form-group v-if="UpdateEnquiry.status_id === isDeadStatus">
                                      <label>Dead Reason<span class="text-danger">*</span></label>
                                        <b-form-select v-model="UpdateEnquiry.dead_reason" @input="GetDeadReasonQuestion(UpdateEnquiry.dead_reason)" :required="UpdateEnquiry.status_id === isDeadStatus" :options="DeadReasonList"></b-form-select>
                                    </b-form-group>
                                    <b-form-group v-if="UpdateEnquiry.status_id === isDeadStatus">
                                      <label>{{Question}}<span class="text-danger">*</span></label>
                                        <b-form-textarea placeholder="Dead Reason Comment" :required="UpdateEnquiry.status_id === isDeadStatus" v-model="UpdateEnquiry.dead_reason_comment" rows="3" max-rows="5"></b-form-textarea>
                                    </b-form-group>
                                    <b-form-group>
                                      <label>Comment<span class="text-danger">*</span></label>
                                        <div v-html="UpdateEnquiry.comment"></div>
                                        <b-form-textarea placeholder="Add Comment" v-model="UpdateEnquiry.executive_comments" required rows="3" max-rows="5"></b-form-textarea>
                                    </b-form-group>
                                    <b-form-group class="mt-2">
                                        <b-button variant="primary" type="submit" block>Save</b-button>
                                    </b-form-group>
                                  </b-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import {decodeEnquiryParams, DEAD_STATUS_ID} from '@/assets/scripts/utility.js';
import { Datetime } from 'vue-datetime';
export default {
  name: 'EditCampaign',
  components: {
    datetime: Datetime
  },
  data() {
    return {
      UpdateEnquiry: {},
      queryP: {},
      comment: '',
      Question: '',
      NriList: [{value: null, text: 'Select One'}, {value: true, text: 'Yes'}, {value: false, text: 'No'}],
      VCMList: [{ value: null, text: 'Select One' },
       {value: true, text: 'Yes'},
       {value: false, text: 'No'}],
      VisitedList: [{ value: null, text: 'Select One' },
       {value: true, text: 'Yes'},
       {value: false, text: 'No'}],
      OBMList: [{ value: null, text: 'Select One' },
       {value: true, text: 'Yes'},
       {value: false, text: 'No'}]
    }
  },
  computed: {
    StatusList() {
      return this.$store.getters.EnquirystatusesMaster;
    },
    DeadReasonList() {
      return this.$store.getters.DeadReasonMaster;
    },
    isDeadStatus(){
      return DEAD_STATUS_ID;
    }
  },
  created() {
    this.GetEnquiryOnEdit(this.$route.params.id)
    this.Question = 'Dead Reason Comment'
  },
  methods: {
    CheckVistedValidation(row) {
      if (row === false) {
        this.UpdateEnquiry.visit_date = null
      }
    },
    CheckVCMValidation(row) {
      if (row === false) {
        this.UpdateEnquiry.vcm_done_date = null
      }
    },
    CheckOBMValidation(row) {
      if (row === false) {
        this.UpdateEnquiry.obm_done_date = null
      }
    },
    CheckStatusValidation(row) {
      if (row !== DEAD_STATUS_ID) {
        this.UpdateEnquiry.dead_reason = null
        this.UpdateEnquiry.dead_reason_comment = null
        this.Question = 'Dead Reason Comment'
      }
    },
    GetDeadReasonQuestion(row) {
      for (let reason of this.DeadReasonList) {
        if (row === reason.value) {
          this.Question = reason.question
        }
      }
    },
    GetEnquiryOnEdit(id) {
      this.queryP = {}
      this.queryP['id'] = id
      this.$axios.get(`enquiries_builders/${this.queryP.id}`, { params: this.queryP }).then((res) => {
        this.UpdateEnquiry = res.data.enquiry
        this.UpdateEnquiry.visit_date = this.UpdateEnquiry.enquiry_visit_date
        this.UpdateEnquiry['executive_comments'] = null
        if (this.UpdateEnquiry.comment !== null) {
          this.UpdateEnquiry.comment = this.UpdateEnquiry.comment.replaceAll('\n', '<br>')
        }
      });
    },
    UpdateEnquiryDetails () {
      let apiParams = decodeEnquiryParams(this.UpdateEnquiry);
      this.$axios
      .put(`enquiries_builders/${this.queryP.id}`,{ enquiry: apiParams })
      .then((res) => {
        swal({
          title: "Enquiry Updated!",
          icon: "success",
        }).then(this.$router.replace({ name: "Details", params: { id: this.UpdateEnquiry.id } }));
      })
      .catch((err) => {
        if (err.response.status === 500) {
          swal({
            title: "Server Error!",
            icon: "error",
          });
        } else {
          swal({
            title: "Error",
            text: err.response.data.message,
            icon: "error",
          });
        }
      });
    },
  }
}
</script>